import { handleError } from 'utilities/utilities';
import { getAgencyApiHost } from '../host-by-env';
import { PrismGenerateReport, PrismUserProfile } from './types';

export const getPrismRouteName = async (firmId: number, token: string) => {
  const url = `${getAgencyApiHost()}common-service/v1/propertyProfile/PrismRouteName/${firmId}`;
  const response = await fetch(url, {
    method: 'GET',
    headers: { Authorization: `Bearer ${token}` },
  });
  const json = await response.json();
  handleError(json);
  return json.Result;
};

export const createPrismUser = async (payload: PrismUserProfile, token: string) => {
  const url = `${getAgencyApiHost()}common-service/v1/propertyProfile/createPropertyUser`;
  const response = await fetch(url, {
    method: 'POST',
    body: JSON.stringify(payload),
    headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
  });
  const json = await response.json();
  const createPrismUserResponse = json.Result;
  return createPrismUserResponse;
};

export const generateReport = async (payload: PrismGenerateReport, token: string) => {
  const url = `${getAgencyApiHost()}common-service/v1/propertyProfile/generateReport`;
  let errorMsg;
  let generateReportResponse: any = {};
  const response = await fetch(url, {
    method: 'POST',
    body: JSON.stringify(payload),
    headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
  }).catch(() => {
    errorMsg = 'Please try again later or visit Property Reports located in the main menu under Services.';
  });

  if (response) {
    const json = await response.json();
    generateReportResponse = json.Result;
  } else {
    generateReportResponse.Error = errorMsg;
  }

  return generateReportResponse;
};
